import { ApiRequestError } from '@/lib/fetcher';

// error_code values api-ai-transform answers (409) with when a create or a
// rename would reuse the exact name of a connector or an MCP server the
// workspace has. Endpoint URLs may repeat (AIS-2667).
export const DUPLICATE_ERROR = {
  connectorName: 'SYSTEM_NAME_EXISTED',
  mcpName: 'MCP_NAME_EXISTED',
} as const;

export function isDuplicateError(
  error: unknown,
  code: (typeof DUPLICATE_ERROR)[keyof typeof DUPLICATE_ERROR],
): boolean {
  return error instanceof ApiRequestError && error.errorCode === code;
}
